module.exports = __webpack_public_path__ + "img/snap-inc.aa3ced21.png";